import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { func } from "../../Utilities/logFunc";
import moment from "moment";
import Diamond from '../../assets/new-images/coin.svg'
import { url } from "../../Utilities/url";
import {
  getDailyReward,
  getAccountDailyReward,
  getAccountProfile,
  getHeaderApi,
} from "../../Utilities/controller";
import { toast } from "react-toastify";
import { useProfileDataContext } from "../HomePage/ProfileContext";
import { useTranslation } from "react-i18next";
import Loader from "../Common/Loader";

import {eventTracking} from "../../firebaseAnalytics"; 
import {events} from "../../Utilities/appEvents";
import { collectDailyRewards } from "../../Utilities/withJwtController";
import GoogleRewarded from "../GoogleAds/GoogleRewarded";

const DailyLoginRewards = ({ handleClose, isPopup }) => {
  const { t } = useTranslation();

  const currentDayActiveBtnRef = useRef(null);
  const currentDayActiveBtnRef2 = useRef(null);
  const dailyLoginDetailsCardRef = useRef(null);
  const adBlockRef = useRef(null);

  const [isLoading, setLoading] = useState(false);
  const [dailyRewardList, setDailyRewardList] = useState([]);
  const [accountDailyReward, setAccountDailyReward] = useState(null);

  // NEW: control ad visibility
  const [showAd, setShowAd] = useState(false);

  const { profileData, updateProfileData } = useProfileDataContext();

  const getCurrentDayItem = (day) => {
    if (day < accountDailyReward?.currentDay) return 1;
    if (day === accountDailyReward?.currentDay) return 2;
    return 3;
  };

  const fetchDailyRewardList = async () => {
    try {
      const data = {
        skip: 0,
        limit: 100,
        day: accountDailyReward?.currentDay,
        sortBy: "day",
        sort: "asc",
      };
      const res = await getDailyReward(data);
      if (res?.data?.list) setDailyRewardList(res?.data?.list);
      func(res);
    } catch (error) {
      func("avatar 13", error?.response?.data?.errors?.[0]?.msg);
    }
  };

  useEffect(() => {
    if (dailyRewardList?.length > 0) {
      const currentDayActiveBtn = currentDayActiveBtnRef.current;
      const dailyLoginDetailsCard = dailyLoginDetailsCardRef.current;
      if (currentDayActiveBtn && dailyLoginDetailsCard) {
        const scrollTopValue =
          currentDayActiveBtn.offsetTop - dailyLoginDetailsCard.offsetTop;
        dailyLoginDetailsCard.scrollTo({ top: scrollTopValue, behavior: "smooth" });
      }
    }
  }, [dailyRewardList]);

  const fetchAccountDailyRewardList = async () => {
    try {
      const res = await getAccountDailyReward();
      if (res?.data?.success) setAccountDailyReward(res?.data?.item);
      func(res);
    } catch (error) {
      toast.error(error?.response?.data?.errors?.[0]?.msg);
      func("avatar 13", error?.response?.data?.errors?.[0]?.msg);
    }
  };

  const getTotalCoin = (wallet) => {
    let index = wallet.findIndex((obj) => obj.currencyData?.code == "D11");
    if (index > -1) return wallet[index].winningAmount ? wallet[index].winningAmount : 0;
    return 0;
  };

  const handlerClaim = async (id, item) => {
    try {
      setLoading(true);
      const payload = { dailyReward: id };
      const res = await collectDailyRewards(payload);
      if (res) {
        const resProfile = await getHeaderApi();
        if (resProfile?.data) {
          eventTracking(events.DAILY_LOGIN_REWARD, {
            GJ_ClaimAmount: item.amount,
            GJ_CurrentDay: item.day,
          });

          updateProfileData(resProfile?.data);
          await fetchAccountDailyRewardList();

          toast.success(t("daily_reward"));
          setShowAd(true); // ⬅️ SHOW THE AD RIGHT AFTER SUCCESS

          // OPTIONAL: scroll the ad into view
          setTimeout(() => {
            adBlockRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 100);

          // NOTE: Don't close immediately—let user see the ad.
          // If you want to auto-close after some time, uncomment below:
          // setTimeout(() => { handleClose && handleClose(); }, 3500);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.errors?.[0]?.msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccountDailyRewardList();
  }, []);

  useEffect(() => {
    fetchDailyRewardList();
  }, [accountDailyReward]);

  return (
    <div className="ps-lg-3">
      <h2 className="h3 bodyBoldFont mb-4 text-center text-dark">
        {t("Profile.daily_login_rewards")}
      </h2>

      <div className="card dailyloginCard mb-2">
        <div className="card-header">
          <div className="row justify-content-between align-items-center">
            <div className="col-4 d-flex justify-content-around">
              <h5 className="bodyNormalFont h4 mb-0 text-black">{t("Profile.login_rewards")}</h5>
            </div>
            <div className="col-4 d-flex justify-content-between align-items-center">
              <div className="col text-center">
                <h5 className="bodyNormalFont h4 mb-0 text-black">{t("Profile.day")}</h5>
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex justify-content-between">
                <div className="col text-center">
                  <h5 className="bodyNormalFont h4 mb-0 text-black">{t("Profile.status")}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card dailyLoginDetailsCard mb-4">
        <div
          className="card-body dailyLoginDetailsCard-2"
          ref={dailyLoginDetailsCardRef}
          style={{ overflowY: "scroll" }}
        >
          <ul className="list-unstyled mb-0">
            {dailyRewardList.length > 0 &&
              dailyRewardList.map((item, ind) => (
                <li
                  ref={item.day == accountDailyReward?.currentDay ? currentDayActiveBtnRef : currentDayActiveBtnRef2}
                  className={`row justify-content-between align-items-center ${
                    item.day == accountDailyReward?.currentDay ? "current-day-active-btn" : ""
                  }`}
                  key={ind}
                  style={{ padding: "0.75rem" }}
                >
                  <div className="col-4 d-flex justify-content-around">
                    {item?.avatar && item?.avatar?.img && item?.avatar?.img?.default ? (
                      <h6 className="mb-1 h5 text-white d-flex justify-content-center align-items-center">
                        {item?.avatar?.name}
                        <img
                          src={url?.imageUrl + item?.avatar?.img?.default}
                          className="mx-2 icon-20"
                          alt="reward"
                        />
                      </h6>
                    ) : (
                      <h6 className="mb-1 h5 text-white d-flex justify-content-center align-items-center">
                        +{item?.amount}
                        <span className="mx-2">
                          {item?.currency ? (
                            <img
                              src={url?.imageUrl + item?.currency?.img?.default}
                              className="icon-20"
                              alt="currency"
                            />
                          ) : (
                            <img src={Diamond} className="icon-20" alt="coin" />
                          )}
                        </span>
                      </h6>
                    )}
                  </div>

                  <div className="col-4 d-flex justify-content-between">
                    <div className="col text-center">
                      <h5 className="bodyNormalFont mb-0">{t("Profile.dayData", { n: item.day })}</h5>
                    </div>
                  </div>

                  <div className="col-4 text-center d-flex justify-content-center">
                    {item?.day < accountDailyReward?.currentDay ? (
                      <div className="d-grid">
                        <button
                          style={{ textTransform: "capitalize" }}
                          className="btn btn-sm bg-dark text-black mx-2 my-1 d11-claim-btn"
                          disabled
                        >
                          {t("Profile.claimed")}
                        </button>
                      </div>
                    ) : item.day === accountDailyReward?.currentDay ? (
                      accountDailyReward?.isDailyRewardPopup ? (
                        <button
                          className="btn btn-sm bg-dark text-black mx-2 my-1 d11-claim-btn"
                          style={{ textTransform: "capitalize" }}
                          onClick={() => handlerClaim(item?._id, item)}
                        >
                          {t("Profile.claim")}
                        </button>
                      ) : (
                        <div className="d-grid">
                          <button
                            style={{ textTransform: "capitalize" }}
                            className="btn btn-sm bg-dark text-black mx-2 my-1 d11-claim-btn"
                            disabled
                          >
                            {t("Profile.claimed")}
                          </button>
                        </div>
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </li>
              ))}
          </ul>

          {/* ⬇️ Interstitial Ad block appears AFTER successful claim */}
        {showAd && (
  <GoogleRewarded
    adUnitPath="/157165500,23206251223/MCM_Gj_Console/MCM_Gj_Console_rewarded_1"
    show={showAd}
    onGranted={() => {
      // Optional: credit double-reward, log, etc.
      // toast.success(t("reward_unlocked"));
    }}
    onClosed={() => {
      // Close the popup or just hide the "showAd" state
      setShowAd(false);
      // handleClose && handleClose(); // if you want to close the modal too
    }}
  />
)}
        </div>
      </div>

      {isLoading ? <Loader /> : null}
    </div>
  );
};

export default DailyLoginRewards;
